<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Games from "@/services/Games";
import modalAddQuizQuestion from "@/components/modals/games/modalAddQuizQuestion.vue";
import modalEditQuizQuestion from "@/components/modals/games/modalEditQuizQuestion.vue";
import Swal from "sweetalert2";
import Monitor from "@/services/Monitor";

export default {
  components: {
    Layout,
    PageHeader,
    modalAddQuizQuestion,
    modalEditQuizQuestion,
  },
  page: {
    title: "Quiz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      selectedPollData:null,
      isAuthorized: false,
      error: null,
      tableData: [],
      selectedQuestion: null,
      title: "Quiz",
      items: [
        {
          text: "Fanzone",
          href: "#",
        },
        {
          text: "Quiz",
          active: true,
        },
      ],
      isBusy: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created_on",
      sortDesc: true,
      approvalLoading: {},
      fields: [
        {
          key: "team_id",
          label: "Team",
          sortable: true,
        },
        {
          key: "question",
          label: "Question",
          sortable: true,
        },
        {
          key: "image",
          label: "Image",
          sortable: true,
        },
        {
          key: "difficulty",
          label: "Difficulty",
          sortable: true,
        },
        {
          key: "ai_model",
          label: "AI Model",
          sortable: true,
        },
        {
          key: "is_approved",
          label: "Is Approved",
          sortable: true,
        },
        {
          key: "is_rejected",
          label: "Is Rejected",
          sortable: true,
        },
        {
          key: "created",
          label: "Created",
          sortable: true,
        },
        "action"
      ],
    };
  },

  computed: {
  },

  // filters: {
  //   capitalize(value) {
  //     if (!value) return '';
  //     return value.charAt(0).toUpperCase() + value.slice(1);
  //   }
  // },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    modalAddNewPoll(){
      this.$bvModal.show('add_new_quiz_question')
    },
    openEditModal(question) {
      if (!question?.id) {
        return;
      }

      // Open modal immediately with basic question data
      // The modal will fetch detailed data (with translations/answers) in the background
      this.selectedQuestion = question;
      this.$refs.editQuizQuestionModal?.open(question);
    },
    async toggleQuestionApproval(question) {
      if (!question?.id || this.approvalLoading[question.id]) {
        return;
      }

      const previousStatus = question.is_approved ? 1 : 0;
      const nextStatus = previousStatus ? 0 : 1;
      question.is_approved = nextStatus;
      this.$set(this.approvalLoading, question.id, true);

      const formData = new FormData();
      formData.append('csrf_token', this.csrf_token ?? '');
      formData.append('_method', 'PATCH');
      formData.append('is_approved', nextStatus);

      try {
        await Games.editQuizQuestion(question.id, formData);
        this.$bvToast?.toast(
          nextStatus ? 'Question approved' : 'Question unapproved',
          {
            title: 'Success',
            variant: 'success',
            solid: true,
          }
        );
      } catch (error) {
        question.is_approved = previousStatus;
        const err =
          error?.response?.data?.error
            ? Array.isArray(error.response.data.error)
              ? error.response.data.error.join(', ')
              : error.response.data.error
            : error?.message || 'Failed to update approval status';
        this.$bvToast?.toast(err, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.$set(this.approvalLoading, question.id, false);
      }
    },
    async getQuizQuestion(){
      try {
        this.toggleBusy();
        const response = await Games.getQuizQuestion();
        this.tableData = response.data.data;
        this.totalRows = this.tableData.length
      } catch (error) {
        this.error = error?.response?.data?.error ?? "";
        this.tableData = [];
        this.totalRows = 0;
      } finally {
        this.toggleBusy();
      }
    },
    confirmDeleteQuestion(question) {
      Swal.fire({
        title: "Delete Quiz Question?",
        text: "This quiz question will be permanently removed.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it"
      }).then(async (result) => {
        if (result.value) {
          try {
            await Games.deleteQuizQuestion(question.id);
            Swal.fire("Deleted!", "Quiz question has been removed.", "success");
            this.getQuizQuestion();
          } catch (error) {
            const errMsg = error?.response?.data?.error
              ? (Array.isArray(error.response.data.error)
                ? error.response.data.error[0]
                : error.response.data.error)
              : "Failed to delete quiz question";
            Swal.fire("Failed!", errMsg, "error");
          }
        }
      });
    },
  },
  mounted() {
    this.getQuizQuestion();
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-body">
            <div>
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                 @click="modalAddNewPoll">
                <i class="mdi mdi-plus me-2"></i>
                Create New Quiz Question
              </a>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6 mb-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-medium me-3 mb-0">Show:</label>
                  <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="me-3"
                      style="width: auto;"
                  ></b-form-select>
                  <span class="text-muted">entries per page</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 mb-3">
                <div class="d-flex align-items-center justify-content-md-end">
                  <label class="form-label fw-medium me-2 mb-0">Search:</label>
                  <div class="position-relative" style="width: 250px;">
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search questions..."
                        class="form-control"
                    ></b-form-input>
                    <i class="mdi mdi-magnify position-absolute top-50 end-0 translate-middle-y me-2 text-muted"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No Data Found"
              >

<!--                <template v-slot:cell(active_from)="data">-->
<!--                                <span-->
<!--                                    style="font-size:14px;"-->
<!--                                    class="badge"-->
<!--                                    :class="{-->
<!--                                    'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',-->
<!--                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',-->
<!--                                  }"-->
<!--                                >{{data.item.active_from}}</span>-->
<!--                </template>-->
<!--                <template v-slot:cell(active_to)="data">-->
<!--                                <span-->
<!--                                    style="font-size:14px;"-->
<!--                                    class="badge"-->
<!--                                    :class="{-->
<!--                                    'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',-->
<!--                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',-->
<!--                                  }"-->
<!--                                >{{data.item.active_to}}</span>-->
<!--                </template>-->
                <template v-slot:cell(is_approved)="data">
                  <div class="approval-cell">
                    <div
                      class="status-indicator"
                      :class="data.item.is_approved ? 'approved' : 'pending'"
                    >
                      <span class="dot"></span>
                      <span class="label">
                        {{ data.item.is_approved ? 'Approved' : 'Pending' }}
                      </span>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="!!data.item.is_approved"
                      :disabled="approvalLoading[data.item.id]"
                      @change="() => toggleQuestionApproval(data.item)"
                      class="approval-switch"
                    >
                      <span class="sr-only">Toggle approval</span>
                    </b-form-checkbox>
                  </div>
                </template>
                <template v-slot:cell(is_rejected)="data">
                  {{ data.item.is_rejected === 1 ? 'Yes' : 'No' }}
                </template>


                <template v-slot:cell(image)="data">
                  {{ data.item.image ? 'Yes' : 'No' }}
                </template>

<!--                <template  v-slot:cell(statistics)="data">-->
<!--                  <span>{{data.item.statistics.total_votes}}</span>-->

<!--                </template>-->

                <template v-slot:cell(action)="data">
                  <ul class="list-inline mb-0 d-flex gap-2">
                    <li class="list-inline-item">
                      <a :href="`/games/quiz/question/${data.item.id}`" title="View Answer Statistics">
                        <i  style="color: #5b73e8;" class="uil uil-eye font-size-18"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" title="Edit" @click="openEditModal(data.item)">
                        <i class="uil uil-pen font-size-18 text-primary"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" title="Delete" @click="confirmDeleteQuestion(data.item)">
                        <i class="uil uil-trash-alt font-size-18 text-danger"></i>
                      </a>
                    </li>
                  </ul>
                </template>


                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalAddQuizQuestion @onRefresh="getQuizQuestion"></modalAddQuizQuestion>
    <modalEditQuizQuestion ref="editQuizQuestionModal" @onRefresh="getQuizQuestion"></modalEditQuizQuestion>
  </Layout>
</template>

<style scoped>
/* Filter Card Styling */
.card {
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Status Filter Cards */
.border {
  border-color: #e9ecef !important;
  transition: all 0.2s ease;
}

/* .border:hover {
  border-color: #5b73e8 !important;
  box-shadow: 0 2px 8px rgba(91, 115, 232, 0.1);
} */

/* Badge Styling */
.badge {
  font-size: 0.75rem;
  font-weight: 500;
}

.bg-success-subtle {
  background-color: rgba(40, 167, 69, 0.1) !important;
  color: #28a745 !important;
}

.bg-danger-subtle {
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #dc3545 !important;
}

.bg-info-subtle {
  background-color: rgba(13, 202, 240, 0.1) !important;
  color: #0dcaf0 !important;
}

.bg-warning-subtle {
  background-color: rgba(255, 193, 7, 0.1) !important;
  color: #ffc107 !important;
}

/* Form Switch Styling */
.form-check-input:checked {
  background-color: #5b73e8;
  border-color: #5b73e8;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
}

/* Search Input Styling */
.form-control:focus {
  border-color: #5b73e8;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
}

/* Button Styling */
.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  transform: translateY(-1px);
}

/* Active Filter Badges */
.badge.bg-success {
  background-color: #28a745 !important;
}

.badge.bg-danger {
  background-color: #dc3545 !important;
}

.badge.bg-info {
  background-color: #0dcaf0 !important;
}

.badge.bg-warning {
  background-color: #ffc107 !important;
  color: #000 !important;
}

.badge.bg-primary {
  background-color: #5b73e8 !important;
}

/* Icon Styling */
.mdi {
  font-size: 1.1em;
}

/* Header Styling */
.card-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .d-flex.flex-column.gap-2 {
    gap: 0.5rem !important;
  }
  
  .position-relative {
    width: 100% !important;
  }
}

/* Animation for filter changes */
.badge {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Custom scrollbar for select dropdowns */
.form-select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
}

/* Enhanced focus states */
.form-check-input:focus,
.form-select:focus,
.form-control:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
  border-color: #5b73e8;
}

/* Subtle hover effects */
.form-check-label:hover {
  color: #5b73e8;
  cursor: pointer;
}

/* Loading state styling */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.approval-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 50%;
  min-width: 170px;
}

.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.1rem 0.6rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.status-indicator .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-indicator.approved {
  background: rgba(40, 199, 111, 0.12);
  color: #28c76f;
}

.status-indicator.approved .dot {
  background: #28c76f;
  box-shadow: 0 0 0 3px rgba(40, 199, 111, 0.18);
}

.status-indicator.pending {
  background: rgba(130, 134, 139, 0.12);
  color: #82868b;
}

.status-indicator.pending .dot {
  background: #82868b;
  box-shadow: 0 0 0 3px rgba(130, 134, 139, 0.18);
}

.approval-switch :deep(.custom-control-input:focus ~ .custom-control-label::before) {
  box-shadow: none;
}

.approval-switch :deep(.custom-control-input:checked ~ .custom-control-label::before) {
  background-color: #34c38f;
  border-color: #34c38f;
}

.approval-switch :deep(.custom-control-label::before) {
  width: 3rem;
  height: 1.5rem;
}

.approval-switch :deep(.custom-control-label::after) {
  width: 1.1rem;
  height: 1.1rem;
  top: calc(0.2rem + 1px);
}

.approval-switch
  :deep(.custom-control-input:checked ~ .custom-control-label::after) {
  transform: translateX(1.45rem);
}
</style>
